<template>
	<div class="chat-fans-transfer">
		<div class="chat-fans-transfer-title">
			<span class="chat-chat-ot-name">转移与<span>{{chatUser.fans_wx_name}}</span>的对话信息</span>
			<span class="chat-chat-ot-close" @click="closeOrder">关闭</span>
		</div>
		<div class="chat-fans-transfer-search">
			<input type="text" v-model="requestParam.manager_name" placeholder="管理员名称">
			<button type="button" @click="search">搜索</button>
		</div>
		<div class="chat-fans-transfer-box">
			<div class="chat-fans-transfer-wrap">
				<table class="layui-table" v-if="type === 1">
				  <thead>
				    <tr>
						<th>ID</th>
						<th>管理员名称</th>
						<th>岗位</th>
						<th>部门</th>
						<th width="80">操作</th>
				    </tr> 
				  </thead>
				  <tbody v-if="managerList.length > 0">
				    <tr v-for="manager in managerList">
				      <td>{{manager.id}}</td>
				      <td>{{manager.manager_name}}</td>
					  <td>{{manager.department}}</td>
					  <td>{{manager.title}}</td>
					  <td><button class="chat-fans-transfer-button" @click="transfer(manager)">转聊天</button></td>
				    </tr>
				  </tbody>
				  <tbody v-else>
					  <tr>
						  <td colspan="8" style="text-align: center;">暂无管理员信息</td>
					  </tr>
				  </tbody>
				</table>
				<table class="layui-table" v-else-if="type === 2">
				  <thead>
				    <tr>
						<th>转移前管理员</th>
						<th>转移后管理员</th>
						<th>层级</th>
						<th>转移时间</th>
						<th width="80">操作</th>
				    </tr> 
				  </thead>
				  <tbody v-if="managerList.length > 0">
				    <tr v-for="manager in managerList">
				      <td>{{manager.m_name}}</td>
				      <td>{{manager.tm_name}}</td>
					  <td>{{manager.level}}</td>
					  <td>{{manager.create_time}}</td>
					  <td><button class="chat-fans-transfer-button" @click="transfer(manager)" v-if="manager.can_unbind === 1">取消</button></td>
				    </tr>
				  </tbody>
				  <tbody v-else>
					  <tr>
						  <td colspan="8" style="text-align: center;">暂无管理员信息</td>
					  </tr>
				  </tbody>
				</table>
			</div>
		</div>
		<div class="chat-fans-transfer-page">
			<page-component
				:dataApi="dataApi" 
				:requestParams="requestParam" 
				@page-call="pageCall($event)" 
				key="chat-fans-transfer-page"
				ref="ChatChatOrderPage">
			</page-component>
		</div>
	</div>
</template>

<script>
	import PageComponent from '../../components/PageComponent.vue'
	import {webGetList,fansTransfer} from '../../network/web/manager.js'
	import {getLoginInfo} from '../../functions/Common.js'
	
	export default{
		name:"ChatFansTransfer",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		components:{
			PageComponent
		},
		data(){
			return {
				type: 1,
				managerList: [],
				dataApi: webGetList,
				requestParam:{
					manager_name:'',
					prePage: 10,
					manager_id: 0,
					fans_id: 0
				},
			}
		},
		methods:{
			// 关闭页面
			closeOrder(){
				this.$emit('chat-fans-transfer-close')
			},
			
			// 分页数据回调
			pageCall(data){
				if(data.length > 0 && data[0]['can_unbind'] !== undefined){
					this.type = 2
				}else{
					this.type = 1
				}
				this.managerList = data
			},
			
			// 搜索
			search(){
				this.$refs.ChatChatOrderPage.initPage()
			},
			
			// 对话转移操作
			transfer(manager){
				let manager_info = getLoginInfo()
				if(manager_info === false){
					CHAT_LAYER.msg('刷新页面后重试！')
					return
				}
				let _this = this
				CHAT_LAYER.confirm('确定要将对话转给<span style="color:red">'+manager.manager_name+'</span>吗？', {
					title: '信息确认',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					let param = {
						manager_id: manager_info.id,
						t_manager_id: manager.id,
						fans_id: _this.chatUser.fans_id
					}
					fansTransfer(param,data=>{
						if(data === false){
							CHAT_LAYER.msg('操作失败',{icon: 2})
						}else{
							CHAT_LAYER.msg('操作成功',{icon: 1})
							_this.$emit('chat-fans-transfer-close',data)
						}
					})
				}, function(index2){
					//按钮【按钮二】的回调
				});
			}
		},
		created() {
			let manager_info = getLoginInfo()
			this.requestParam.manager_id = manager_info.id
			this.requestParam.fans_id = this.chatUser.fans_id
		}
	}
</script>

<style>
	.chat-fans-transfer{
		position: absolute;
		top: 105px;
		left: 20px;
		bottom: 105px;
		right: 20px;
		background-color: #FFFFFF;
		z-index: 11;
	}
	.chat-fans-transfer-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.chat-chat-ot-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.chat-chat-ot-name span{
		font-weight: bold;
	}
	.chat-fans-transfer-search{
		height: 28px;
		padding: 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-fans-transfer-search input{
		height: 26px;
		line-height: 26px;
		width: 170px;
		border: 1px solid #CCCCCC;
		padding: 0 5px;
		border-radius: 2px;
		color: #666666;
		margin-right: 3px;
	}
	.chat-fans-transfer-search button{
		padding: 0 10px;
		line-height: 28px;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
	}
	.chat-fans-transfer-box{
		position: absolute;
		top: 80px;
		left: 0;
		right: 0;
		bottom: 60px;
		overflow: hidden;
	}
	.chat-fans-transfer-box .chat-fans-transfer-wrap{
		position: relative;
		height: 100%;
		padding: 0 10px;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-fans-transfer-wrap>table{
		margin: 0;
		/* table-layout: fixed; */
		word-break: break-all;
	}
	.chat-fans-transfer-page{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 26px;
		padding: 17px 0;
	}
	.chat-fans-transfer-button{
		background-color: #007DDB;
		font-size: 12px;
		color: #FFFFFF;
		padding: 2px 10px;
		border-radius: 2px;
		cursor: pointer;
	}
</style>
